import { Filters } from './filtering';


export namespace Companies {
    export interface BankRequisite {
        Uid: string;
        Name: string;
        INN: string;
        KPP: string;
        BIK: string;
        SettlementAccount: string;
        CorrespondentAccount: string;
        IsForNominalHolder: boolean;

        NotBefore: Date;
        NotAfter: Date;
    }
    export type BankRequisites = BankRequisite[];

    export interface CompanyRequisite {
        ShortName: string;
        FullName: string;
        INN: string;
        KPP: string;
        OGRN: string;
        OKPO: string;
        OKATO: string;
        OKVED: string;
        OKTMO: string;
        DateStart: Date;
        DateClosed: Date;
        FactAddressRegionCode: string;
        FactAddress: string;
        LegalAddressRegionCode: string;
        LegalAddress: string;
    }

    export interface Company extends CompanyRequisite {
        Acronym: string;
        OPF: string;
        OKOPF: string;
        FactAddressUid: string;
        LegalAddressUid: string;
        StatusDescription: string;
        StatusDate: Date;
        Reorganizing: boolean;
        Bankrupting: boolean;
        Dissolving: boolean;
        Dissolved: boolean;
        Uid: string;
        IsDeleted: boolean;
        Code: string;
    }
    export interface DetailCompany extends Company {
        AllowDfaOwners: boolean;
        AllowDfaIssuers: boolean;
        AllowNominalHolders: boolean;
        DefaultProfileOisKey: string;
        NominalHolderProfileOisKey: string;
        BankRequisites: BankRequisites;
    }

    export interface FilterCompany {
        INN: string;
        Id: number;
        Name: string;
    }

    export interface ClientProfileType {
        Uid: string;
        Type: {
            Mask: number;
            Uid: string;
            Name: string;
            Code: string;
        };
    }

    export type ClientProfileTypes = ClientProfileType[];

    export enum ClientProfiles {
        None = 'None',
        Default = 'Default',
        NominalHolder = 'NominalHolder',
    }
}

export const companiesFilters = {
    name: <Filters.FilterWithApply>{
        api: ({ value }) => ({
            name: value,
        }),
        applyFilter: (value, { ShortName }) =>
            value === ShortName,
    },
    role: <Filters.FilterWithApply>{
        api: ({ value }) => ({
            roleCode: value,
        }),
        applyFilter: (value, { Code }) =>
            value === Code,
    },
};
